import ajax from '@/utils/ajax';

export const head = '/web';
// 换课单列表
export const reqReplaceList = (data) => ajax(`${head}/v1/change/user-list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&status=${data.status}`);

// 换课单详情
export const reqReplaceDetail = (changeNo) => ajax(`${head}/v1/change/user-detail?changeNo=${changeNo}`);

// 退课列表
export const reqExitClassList = (data) => ajax(`${head}/v1/refund/user-list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&status=${data.status}`);

// 退课详情
export const reqExitDetail = (refundNo) => ajax(`${head}/v1/refund/user-detail?refundNo=${refundNo}`);
